import styled from "styled-components"

import { spacing } from "@minuthq/meatball-ui-react"

import { MCard } from "src/ui/MCard/MCard"
import { MSkeleton } from "src/ui/MSkeleton/MSkeleton"

export function IntegrationsCardSkeleton({
  boxShadow = true,
  border = false,
}: {
  boxShadow?: boolean
  border?: boolean
}) {
  return (
    <CardBox padding={spacing.L} boxShadow={boxShadow} border={border}>
      <ContentBox>
        <MSkeleton variant="rect" height={56} width={56} />
        <div>
          <MSkeleton variant="text" width={150} />
          <MSkeleton variant="text" />
        </div>
      </ContentBox>
    </CardBox>
  )
}

const CardBox = styled(MCard)`
  display: grid;
  gap: ${spacing.M};
`

const ContentBox = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: ${spacing.L};
`
